import { render } from "./block_video.vue?vue&type=template&id=442fe93f&scoped=true"
import script from "./block_video.vue?vue&type=script&lang=js"
export * from "./block_video.vue?vue&type=script&lang=js"

import "./block_video.vue?vue&type=style&index=0&id=442fe93f&scoped=true&lang=css"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442fe93f"]])

export default __exports__